
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/team-triphunters-favourites",
      function () {
        return require("private-next-pages/blog/team-triphunters-favourites.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/team-triphunters-favourites"])
      });
    }
  